import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withSnackbar } from "notistack";
import IsEmpty from "../ChecklistList/NoContent";
import "../ChecklistList/Checklist.scss";
import ChecklistView from "./ChecklistView";
// import ChecklistView from '../ChecklistList/ListView';
import { instance } from "../../../../../../Actions/AxiosInstance";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { CheckActionPermission } from "Actions/commonAction";

class ChecklistList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
      loading: false,
      activeAssignlist: [],
      inactiveAssignlist: [],
      completedAssignlist: [],
      noContentHeader: "There are no checklists assigned to you yet!",
      noContentText: "Phew, no work to do here!",
      isShared: false,
    };
    this.getEmpCheclist = this.getEmpCheclist.bind(this);
  }

  async componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("checklist");
    if (isTrue) {
      this.setState({ permissions });
      await this.getEmpCheclist(false);
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  async getEmpCheclist(isShared) {
    try {
      const assignList = await instance.get(
        `checklist/empchecklist/${isShared}`,
      );
      this.setState({
        activeAssignlist: assignList.data.result[0].checklistdata.isactive,
        inactiveAssignlist: assignList.data.result[0].checklistdata.inactive,
        completedAssignlist: assignList.data.result[0].checklistdata.iscomplete,
        isShared,
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const listLength = this.state.activeAssignlist.length;
    const { activeAssignlist, inactiveAssignlist, completedAssignlist } =
      this.state;
    return (
      <div className="content-outer-wrapper">
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            {listLength > 0 || !this.isShared ? (
              <ChecklistView
                {...this.props}
                activeAssignlist={activeAssignlist}
                inactiveAssignlist={inactiveAssignlist}
                completedAssignlist={completedAssignlist}
                onChangetoggle={this.getEmpCheclist}
                isShared={this.state.isShared}
              />
            ) : (
              <IsEmpty
                header={this.state.noContentHeader}
                text={this.state.noContentText}
                editable={this.state.editable}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withSnackbar(ChecklistList));
